module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/instagram-19c4698a8491869c083722c47d74f6a8.svg";